var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"go-back-btn"},[_c('Icon',{staticClass:"go-back-btn__icon",attrs:{"name":"arrow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }